import React, { Component } from "react";
import Timetable from "./timetable";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Timetable></Timetable>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js